<template>
	<div class="isStylePageContent">
		<h4 class="form-block-title">療程方案折扣</h4>
		<FormItemGroup 
		v-if="renderList.length > 0 && submitData.length > 0" 
		:render-list="renderList" type="prepaid"
		:default-value="submitData"
		@updateSubmitData="updateSubmitData" />
	</div>
</template>
  
<script>
import memberLevelDiscountMixin from '@src/mixins/memberLevelDiscountMixin'
import lazyLoadComponent from '@router/lazyload-component'
export default {
	name: 'MemberLevelSettingStep2Prepaid',
	data() {
		return {
			renderList: [], // 純服務列表
			submitData: [], // 此次要渲染的資料(includeDBData)
		};
	},
	props: {},
	watch: {},
	computed: {
	},
	inject: ['dbData', 'isEdit'],
	created() { },
	mixins: [memberLevelDiscountMixin],
	async mounted() {
		await this.fetchList()
		this.composeSubmitData()
	},
	methods: {
		async fetchList() {
			const { items } = await this.$store.dispatch('prepaid/fetchListAll', {
				bookingDateTime: '',
				sizeId: this.petSizeId,
				paginate: 0,
				groupByGroupOrdering: true
			})
			this.renderList = items
		},
		/**
		 * @description 組成submitData
		 */
		composeSubmitData() {
			try {
				this.submitData = this.renderList.reduce((accu, cur) => {
					let rawObj = this.groupAlias('prepaid')
					rawObj = this.findDiscountInDb(cur.groupAlias, rawObj)
					accu.push(rawObj)
					return accu
				}, [])
			} catch (error) {
				console.error(error.message)
			}
		},
		/**
		 * @description 找到已存的discount修改值(for修改初始化) & 放到畫面上
		 * @param {*} groupAlias 
		 * @param {*} rawObj 
		 */
		findDiscountInDb(groupAlias, rawObj) {
			try {
				rawObj['groupAlias'] = groupAlias
				rawObj['id'] = groupAlias
				const index = this.dbData['prepaids'] ? this.dbData['prepaids'].findIndex(item => item.groupAlias === groupAlias) : -1
				if (index > -1) {
					rawObj['discount'] = parseInt(this.dbData['prepaids'][index].discount)
					rawObj['discountType'] = this.dbData['prepaids'][index].discountType
				}
				return rawObj
			} catch (error) {
				console.error(error.message)
			}
		},
	},
	components: {
		FormItemGroup: () => lazyLoadComponent(import('./FormItemGroup')),
	},
};
</script>
  
<style lang="scss" module></style>
  